// globals
const e_root = document.querySelector(':root');

window.addEventListener('load', () => {
  e_root.style.setProperty('--firstViewHeight', `${window.innerHeight}px`);
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})

window.addEventListener('resize', () => {
  e_root.style.setProperty('--vw', `${window.innerWidth}px`);
})
var CFL = {
  UA: {
    raw: function raw() {
      return navigator.userAgent;
    },
    is: function is(_is) {
      var ua = CFL.UA.raw();
      if (_is === 'issp') {
        return CFL.UA.isSp();
      }
    },
    isSp: function isSp() {
      var ua = CFL.UA.raw();
      return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0;
    },
    isTablet: function() {
      var ua = CFL.UA.raw();
      if(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      } else if (ua.indexOf('iPad') > -1
         || (ua.indexOf('Macintosh') > -1 && CFL.UA.Device.isTouch() )
         || ua.indexOf('Android') > 0) {
        return true;
      }

      return false;
    },
    isEdge: function() {
      return this.raw().indexOf('Edge') != -1;
    },
    isIE: function() {
      var ua = CFL.UA.raw();
      return this.raw().indexOf('Trident') != -1 ;
    }
  },
  Device: {
    isTouch: function() {
      return 'ontouchend' in document;
    }
  }
};

var isMobile = function () {
  return (window.matchMedia('(max-width: '+ APP.bp.mobile +'px)').matches)
}

var isPortrait = function() {
  let defaultOrientation = null;
  if('orientation' in window) {
    var o1 = (window.innerWidth < window.innerHeight);
    var o2 = (window.orientation % 180 == 0);
    defaultOrientation = (o1 && o2) || !(o1 || o2);
  }
  if('orientation' in window) {
    // defaultOrientationがtrueの場合、window.orientationが0か180の時は縦
    // defaultOrientationがfalseの場合、window.orientationが-90か90の時は横
    var o = (window.orientation % 180 == 0);
    if((o && defaultOrientation) || !(o || defaultOrientation)) {
      return true;
    } else {
      return false;
    }
  }
}
class Accordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // $("." + this.el).parent().parent().parent().next().addClass('c-accordion__inner').css({'display': 'none'});
    // $("." + this.el).parent().parent().parent().parent().addClass('c-accordion__wrap')

    // $("." + this.el).on('click', function() {
    //   $(this).toggleClass('is-active');
    //   $(this).parent().parent().parent().next().slideToggle();
    // })
    $(function(){
      //クリックで動く
      $('.accTrigger').click(function(){
        if($(this).hasClass('is-open')){
          $(this).toggleClass('is-open');
          $(this).next('.accBody').slideToggle();
        } else {
          $(this).toggleClass('is-open');
          $(this).next('.accBody').slideToggle();
        }
      });
    });
  }
}
class Editor {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-editor p, .c-editor div').each(function(index, el) {
      if(el.textContent == ' ' || el.textContent == '') {
        el.style.height = '1px';
        el.style.marginTop = '1.5rem';
      }
    })
  }
}
class Loading {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const body = document.getElementsByTagName('body')[0];
    const btn = document.getElementById('btn');
    let scrollTop = 0;
    
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('no_scroll');
    
    setTimeout(() => {
      $(".c-loading").fadeOut(500);
      body.style.top = '';
      body.classList.remove('no_scroll');
      window.scrollTo(0, scrollTop);
    }, 800);
  }
}
class Modal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-modal-inner').parent().clone().insertBefore('.c-modal .c-modal-clone');

    $('main .c-modal-inner').parent().remove();

    const body = document.getElementsByTagName('body')[0];
    let scrollTop = 0;

    $(".c-modal-inner").parent().addClass('u-mt-0');

    $(".c-modal-trigger").on("click", function() {
      $(`#${$(this).data('id')}, .c-modal-overlay`).addClass('is-active');

      scrollTop = window.scrollY;
      body.style.top = (scrollTop * -1) + 'px';
      body.classList.add('no_scroll');

      return false;
    })

    $(".c-modal-close, .c-modal-overlay").on("click", function() {
      $(`.c-modal-inner, .c-modal-overlay`).removeClass('is-active');
      body.style.top = '';
      body.classList.remove('no_scroll');
      window.scrollTo(0, scrollTop);
    })
  }
}
class Slider {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper('.c-swiper', {
      speed: 500,
      loop: true,
      autoplay: {
        delay: 5000,  
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    })
  }
}

class Tab {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.c-tab-trigger').parent().parent().parent().addClass('u-mb-0');
    $(".c-tab-inner").parent().addClass('c-tab-wrap');
    $(".c-tab-wrap").eq(0).css({'display': 'block'});

    $(".c-tab-trigger li").on('click', function() {
      let el_num = $(this).index();
      $(".c-tab-trigger li").removeClass('is-active');
      $(this).addClass('is-active');

      $('.c-tab-wrap').css({'display': 'none'});
      $('.c-tab-wrap').eq(el_num).css({'display': 'block'});
    })
  }
}
//noScroll
class Common {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // let elFs;

    // $('.c-content *').each(function() {

    //   let css = ['font-size', 'padding-left', 'padding-top', 'padding-right', 'padding-bottom', 'margin-left', 'margin-top', 'margin-right', 'margin-bottom']
    //   let this_el = $(this);

    //   css.forEach(el => {
    //     elFs = this_el.css(el);
    //     if(elFs.match(/([0-9]*)\.[0-9]*(px)/)) {
    //       elFs = elFs.replace(/([0-9]*)\.[0-9]*(px)/, '$1$2');          
    //     }
    //     elFs = elFs.replace(/([0-9])px/, '.$1rem');
    //     this_el.css(el, elFs);
    //   });

    //   // height
    //   if($(this).prop('nodeName').match(/TABLE|TD|TR|TBODY/)) {
    //     elFs = $(this).css('height');
    //     if(elFs.match(/([0-9]*)\.[0-9]*(px)/)) {
    //       elFs = elFs.replace(/([0-9]*)\.[0-9]*(px)/, '$1$2');          
    //     }
    //     elFs = elFs.replace(/([0-9])px/, '.$1rem');
    //     $(this).css('height', elFs);
    //   }
    // })  

    // $('.c-content p').each(function() {
    //   if($(this)[0].innerHTML == '&nbsp;') {
    //     $(this)[0].innerHTML = '';
    //   }
    // });
  }
}
// 参考サイト
// https://hacknote.jp/archives/15289/

var cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class GuidelineTab {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $(".js-tab-content").hide();
    $(".js-tab:first").addClass("is-active");
    $(".js-tab-content:first").show();

    $(".js-tab").click(function(){
      $(".js-tab-content").hide();
      var index = $(this).index();
      $(".js-tab-content").eq(index).show();

      $(".js-tab").removeClass("is-active");
      $(this).addClass("is-active");
    }); 
  }
}
//noScroll
class HeaderScroll {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $(function() {
      const $win = $(window);
      const $header = $('.l-header');
      const $btn = $('.js-hum');

    $win.on('load scroll', function() {
      const value = $(this).scrollTop();
      if ( value > 100 ) {
        $header.addClass('is-small');
        $btn.addClass('is-small');
      } else {
        $header.removeClass('is-small');
        $btn.removeClass('is-small');
      }
      });
    });

  }
}

//noScroll
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.para_ele = document.querySelectorAll("." + this.el);
    this.para_ele.forEach((ele, index)=> {
      if(ele.classList.contains('js-parallax--reverse')) {
        this.translateY = '20px';
      } else {
        this.translateY = '-20px';
      }
      ele.classList.add(this.el + index);
      gsap.to('.' + this.el + index + ' img', {
        translateY: this.translateY,
        scrollTrigger: {
          trigger: '.' + this.el + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          scrub: 3,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

//noScroll
class MenuEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const trigger = document.querySelector(".js-hum");
    const menu = document.querySelector(".menu");
    const entryBtn = document.querySelector(".entry-btn");
    const overlay = document.querySelector(".menu-overlay");
    const body = document.querySelector("body");

    trigger.addEventListener('click',() => {
      trigger.classList.toggle('is-active')
      menu.classList.toggle('is-active')
      entryBtn.classList.toggle('is-hidden')
      overlay.classList.toggle('is-active')
      body.classList.toggle('no_scroll')
    });

    overlay.addEventListener('click',() => {
      trigger.classList.remove('is-active')
      menu.classList.remove('is-active')
      entryBtn.classList.remove('is-hidden')
      overlay.classList.remove('is-active')
      body.classList.remove('no_scroll')
    });
  }
}

//noScroll
class SmoothScroll {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    (function ($) {
      const headerHeight = $('.l-header').outerHeight();
      const urlHash = location.hash;
      if(urlHash) {
        $('body,html').stop().scrollTop(0);
        setTimeout(function(){
          const target = $(urlHash);
          const position = target.offset().top - headerHeight;
          $('body,html').stop().animate({scrollTop:position}, 500);
        }, 800);
      }
      $('a[href^="#"]').click(function(){
        const href= $(this).attr("href");
        const target = $(href);
        const position = target.offset().top - headerHeight;
        $('body,html').stop().animate({scrollTop:position}, 500);
        return false;
      });
    })(jQuery);
  }
}

//noScroll
class SplideEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const mvOptions = {
      type: 'fade',
      speed: 2500,
      interval: 5000,
      autoplay: true,
      pagination: false,
      rewind: true,
      pauseOnHover: false,
    };
    const splide = new Splide(".mv-splide", mvOptions);
    splide.mount();

    const interviewOptions = {
      type: 'loop',
      focus: 0,
      cloneStatus: false,
      perMove: 1,
      speed: 1000,
      gap: '3rem',
      perPage: 3,
      start: 0,
      pagination: true,
      clone: 6,
      drag: false,
      updateOnMove: true,
      breakpoints: {
        767: {
          perPage: 1,
          gap: '2rem',
        },
      },
    };
    const interviewSplide = new Splide(".interview-splide", interviewOptions);
    const bar = interviewSplide.root.querySelector(".progress-bar");
    interviewSplide.on( 'mounted move', function () {
      var end  = interviewSplide.Components.Controller.getEnd() + 1;
      var rate = Math.min( ( interviewSplide.index + 1 ) / end, 1 );
      bar.style.width = String( 100 * rate ) + '%';
    } );
    interviewSplide.mount();
  }
}

//noScroll
class SwiperEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper(".swiper", {
      effect: 'slide',
      loop: true,
      speed: 2000,
      slidesPerView: 1,
      autoplay: {
        delay: 3000,
      },

      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
}



(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  let common = new Common('c-content');
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('.js-inview');
  let splideEvent = new SplideEvent('splide');
  let swiperEvent = new SwiperEvent('swiper');
  let menuEvent = new MenuEvent('js-hum');
  let headerScroll = new HeaderScroll('l-header');
  let accordion = new Accordion('accTrigger');
  let smoothScroll = new SmoothScroll('js-header');
  let guidelinetab = new GuidelineTab('js-guideline-tab');

  // 以下ページビルダー用
  let modal = new Modal('c-modal-trigger');
  let tab = new Tab('c-tab-trigger');
  let swiper = new Slider('c-swiper');
  let loading = new Loading('c-loading');
  let editor = new Editor('c-editor');
});

// スマホ・タブレットの向き判定
// $(window).on('orientationchange', ()=>{
//   if(isPortrait()){
//     console.log('isPortrait');
//   } else {
//     console.log('isLandscape');
//   }
// });